import appGlobalScript from '/builds/1/main-netz/meuikit/components/src/global/global.ts';
export const globalScripts = appGlobalScript;
